import PaymentProviders, { PAYMENT_MODES } from '../../constants/PaymentProviders';
import { PaymentProvider } from '../../domain/entities/Payment/Payment';
import { getPaymentDescriptorId } from '../../payment-strategies/PaymentDescriptor';

// Defines the expected display order of payment methods
export const orderedPaymentMethods: string[] = [
  getPaymentDescriptorId(PaymentProviders.ADYEN_WEB, PAYMENT_MODES.PAY_BY_LINK),
  getPaymentDescriptorId(PaymentProviders.ADYEN_WEB, PAYMENT_MODES.ADYEN_WEB_PAYPAY),
  getPaymentDescriptorId(PaymentProviders.ADYEN_WEB, PAYMENT_MODES.ADYEN_WEB_RAKUTENPAY),
  getPaymentDescriptorId(PaymentProviders.ADYEN_WEB, PAYMENT_MODES.ADYEN_WEB_CC),
  getPaymentDescriptorId(PaymentProviders.ADYEN_WEB, PAYMENT_MODES.ADYEN_WEB_ALIPAY),
  getPaymentDescriptorId(PaymentProviders.ADYEN_WEB, PAYMENT_MODES.ADYEN_WEB_APPLEPAY),
  getPaymentDescriptorId(PaymentProviders.ADYEN_WEB, PAYMENT_MODES.ADYEN_WEB_GOOGLEPAY),
  getPaymentDescriptorId(PaymentProviders.ADYEN_WEB, PAYMENT_MODES.ADYEN_WEB_KLARNA),
  getPaymentDescriptorId(PaymentProviders.ADYEN_WEB, PAYMENT_MODES.ADYEN_WEB_KLARNA_ACCOUNT),
  getPaymentDescriptorId(PaymentProviders.ADYEN_WEB, PAYMENT_MODES.ADYEN_WEB_PAYPAL),
  getPaymentDescriptorId(PaymentProviders.ADYEN_WEB, PAYMENT_MODES.ADYEN_WEB_WECHATPAY),
  getPaymentDescriptorId(PaymentProviders.ADYEN_WEB, PAYMENT_MODES.ADYEN_WEB_BOLETO),
  getPaymentDescriptorId(PaymentProviders.ADYEN_WEB, PAYMENT_MODES.ADYEN_WEB_PIX),
  getPaymentDescriptorId(PaymentProviders.RADIAL),
  getPaymentDescriptorId(PaymentProviders.IYZICO),
  getPaymentDescriptorId(PaymentProviders.INGENICO, PAYMENT_MODES.IDEAL),
  getPaymentDescriptorId(PaymentProviders.INGENICO, PAYMENT_MODES.CREDIT_CARD),
  getPaymentDescriptorId(PaymentProviders.INGENICO, PAYMENT_MODES.SOFORT),
  getPaymentDescriptorId(PaymentProviders.INGENICO, PAYMENT_MODES.PAYPAL),
  getPaymentDescriptorId(PaymentProviders.MERCADO_PAGO, PAYMENT_MODES.MERCADO_PAGO_CC),
  getPaymentDescriptorId(PaymentProviders.RADIAL_ALIPAY),
  getPaymentDescriptorId(PaymentProviders.GMORPay),
  getPaymentDescriptorId(PaymentProviders.COD),
  getPaymentDescriptorId(PaymentProviders.LINE_PAY),
  getPaymentDescriptorId(PaymentProviders.NCCC),
  getPaymentDescriptorId(PaymentProviders.AFTERPAY),
  getPaymentDescriptorId(PaymentProviders.BRAINTREE),
  getPaymentDescriptorId(PaymentProviders.BRAINTREE, PAYMENT_MODES.PAYPAL),
  getPaymentDescriptorId(PaymentProviders.BRAINTREE, PAYMENT_MODES.VENMO),
  getPaymentDescriptorId(PaymentProviders.KUESKI),
  getPaymentDescriptorId(PaymentProviders.MERCADO_PAGO, PAYMENT_MODES.MERCADO_PAGO_CASH),
  getPaymentDescriptorId(PaymentProviders.MERCADO_PAGO, PAYMENT_MODES.MERCADO_PAGO_PSE),
  getPaymentDescriptorId(PaymentProviders.MERCADO_PAGO, PAYMENT_MODES.MERCADO_PAGO_WEBPAY),
  getPaymentDescriptorId(PaymentProviders.GSI_PAYPAL),
  getPaymentDescriptorId(PaymentProviders.PAYPAL),
  getPaymentDescriptorId(PaymentProviders.BELEZA),
  getPaymentDescriptorId(PaymentProviders.MOCKPAY),
  getPaymentDescriptorId(PaymentProviders.PAYU),
  getPaymentDescriptorId(PaymentProviders.GLOBAL_COLLECT, PAYMENT_MODES.CREDIT_CARD_VISA),
  getPaymentDescriptorId(PaymentProviders.GLOBAL_COLLECT, PAYMENT_MODES.AMEX),
  getPaymentDescriptorId(PaymentProviders.GLOBAL_COLLECT, PAYMENT_MODES.CREDIT_CARD_MASTERCARD),
  getPaymentDescriptorId(PaymentProviders.GLOBAL_COLLECT, PAYMENT_MODES.MAESTRO_CARD),
  getPaymentDescriptorId(PaymentProviders.GLOBAL_COLLECT, PAYMENT_MODES.VISA_ELECTRON),
  getPaymentDescriptorId(PaymentProviders.GLOBAL_COLLECT, PAYMENT_MODES.PAYPAL),
  getPaymentDescriptorId(PaymentProviders.GLOBAL_COLLECT, PAYMENT_MODES.SOFORT),
  getPaymentDescriptorId(PaymentProviders.ALTAPAY, PAYMENT_MODES.ALTAPAY_CREDIT_CARD),
  getPaymentDescriptorId(PaymentProviders.ALTAPAY, PAYMENT_MODES.ALTAPAY_MOBILE_PAY),
  getPaymentDescriptorId(PaymentProviders.ALTAPAY, PAYMENT_MODES.ALTAPAY_KLARNA),
  getPaymentDescriptorId(PaymentProviders.ASIAPAY, PAYMENT_MODES.ASIAPAY_CREDIT_CARD),
  getPaymentDescriptorId(PaymentProviders.ASIAPAY, PAYMENT_MODES.ASIAPAY_UNIONPAY),
  getPaymentDescriptorId(PaymentProviders.ASIAPAY, PAYMENT_MODES.ASIAPAY_ALIPAY),
  getPaymentDescriptorId(PaymentProviders.ASIAPAY, PAYMENT_MODES.ASIAPAY_WECHAT_PAY),
];

export function paymentsComparableHandler(
  providerA: PaymentProvider,
  providerB: PaymentProvider,
): number {
  const paymentDescA = getPaymentDescriptorId(
    providerA.providerName,
    providerA.paymentMode,
  );
  const paymentDescB = getPaymentDescriptorId(
    providerB.providerName,
    providerB.paymentMode,
  );

  return orderedPaymentMethods.indexOf(paymentDescA) - orderedPaymentMethods.indexOf(paymentDescB);
}
